<article class="container">
    <section class="filters">
        <app-opportunities-filters
            [filtersKey]="filtersKey"
            [additionalFiltersVisibility]="filtersVisibility"
        ></app-opportunities-filters>
        <button
            type="button"
            class="secondary-btn newOpportunityButton"
            [disabled]="isOpeningModal"
            (click)="onNewOpportunityClicked($event)"
        >
            + New Opportunity
        </button>
    </section>
    <section class="grid">
        <app-opportunities-list [filtersKey]="filtersKey" [companyId]="companyId()"></app-opportunities-list>
    </section>
</article>
